import React, { useState } from 'react';
import { EGerdauHomeContainer } from '../../components/EGerdauHome/styles';
import { DownloadCard, BackIcon } from './styles';
import logoGerdau from '../../assets/images/logo_gerdau.png';
import { Button, message } from 'antd';
import { LongSteelOrdersService } from '../../services/LongSteelOrders';
import FileSaver from 'file-saver';
import { Link, RouteComponentProps, useHistory } from 'react-router-dom';

const ReportsDownload: React.FC<RouteComponentProps> = (props) => {
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [base64File, setBase64file] = useState('');

  const getRequestDate = (): string => {
    const query = new URLSearchParams(props.location.search);

    const date = query.get('date') as string;

    if (!date) {
      history.push('/');
    }

    return date;
  };

  const [requestDate] = useState(getRequestDate()); // YYYY-MM-DD

  const onDownloadClick = () => {
    setLoading(true);
    setHasError(false);
    message.destroy();

    if (base64File === '') {
      LongSteelOrdersService.DownloadReportOrders(requestDate)
        .then((resp) => {
          setBase64file(resp);
          downloadFile(resp);
          setLoading(false);
        })
        .catch((err) => {
          console.error(err);
          setLoading(false);
          setHasError(true);
          message.error('Não foi possível obter a planilha.', 0);
        });
    } else {
      downloadFile(base64File);
      setLoading(false);
    }
  };

  const downloadFile = (file: string) => {
    const blob = b64toBlob(file);
    FileSaver.saveAs(blob, `open-orders-${requestDate}.xlsx`);
  };

  const b64toBlob = (file: string) => {
    const sliceSize = 512;
    const byteCharacters = atob(file);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    return blob;
  };

  return (
    <EGerdauHomeContainer>
      <DownloadCard>
        <header>
          <img src={logoGerdau} alt="logo Gerdau" />
        </header>

        <div className="content">
          <div>
            <h3>Clique para fazer o download da carteira de pedidos</h3>
          </div>

          <Button type="primary" loading={loading} onClick={onDownloadClick}>
            {loading
              ? 'Aguarde...'
              : hasError
              ? 'Tentar novamente'
              : 'Download'}
          </Button>

          <Link to="/" onClick={() => message.destroy()}>
            <BackIcon />
            Voltar à página inicial
          </Link>
        </div>
      </DownloadCard>
    </EGerdauHomeContainer>
  );
};

export default ReportsDownload;
